import React, { useState, useEffect } from "react"
import { Link, useLocation, useHistory } from "react-router-dom"
import { Col, Row, FormGroup, Label, Container, Input, Button } from "reactstrap"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"
import { useWallet } from "../../libs/useMetaMaskWallet"
import { useToast } from "../../hooks/toast"
import Web3 from "web3"
import { ethers } from "ethers"

import { contracts } from "../../Pages/NFTSale/utils"
import { networkIcons } from "../../utils"
import "./NFTCard.scss"
import { voteIdea, voteIdeaVia } from "./ideaViewUtils"
import ideaAbi from "../../abi/IdeaMarketplace.json"
import igspAbi from "../../abi/StakePoolSimpleCombinedNewFTM.json"
import paymasterAbi from "../../abi/ERC721Paymaster.json"

const paymasterContractAddress = "0x14086A82F6Ffb6e4b3bddE5ea844F053bEC5143D"
const ideaContractAddress = "0x739307dc5c36B7Fd4d7B42c533c9408c2c565F35"
const stakeContractAddress = "0xD64281B0E63486B48927AC895c22905638fC696c"

const IdeaCard = ({ idea, idx, stakeIds, refreshIdeas, enableClickNFT = true }) => {
    const web3 = new Web3(window.ethereum)
    const [signer, setSigner] = useState(null)
    const [provider, setProvider] = useState(null)
    const [selectedId, setSelectedId] = useState(null)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const wallet = useWallet()
    const toast = useToast()
    // if enableClickNFT == true, clicking on this component will redirect to nft details page
    // { nft, idx, enableClickNFT = true }
    // const { state } = props.location
    // const { nft, idx } = state
    const history = useHistory()
    const ideaAddress = "collectionAddress"
    const chain = "zksync"
    // const contractOwner = contracts[subdomain]?.[contractType]?.owner
    const ideaSymbol = "IM"
    const elementLink = "https://element.market/assets/zksync/0xd0767d49e0e30b8fb4484d86f0bd1f80abc3e74c/"
    const explorerLink = "https://era.zksync.network/nft/0xd0767d49e0e30b8fb4484d86f0bd1f80abc3e74c/"
    const stakingContractAddress = "0xD64281B0E63486B48927AC895c22905638fC696c"

    // const location = useLocation()
    // const { nftOne, idxOne } = location.state

    const [showImageLoading, setShowImageLoading] = useState(true)
    const [processing, setProcessing] = useState(false)

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const handleResetForm = async () => {
        refreshIdeas()
    }

    const handleVoteIdea = async () => {
        const votedIdea = await voteIdea(
            web3,
            ideaAbi,
            ideaContractAddress,
            wallet.account,
            idea.id,
            stakingContractAddress,
            selectedId,
            setProcessing,
            setMessage,
            handleResetForm
        )
        console.log(votedIdea)
    }

    const handleVoteIdeaVia = async () => {
        const votedIdea = await voteIdeaVia(
            web3,
            signer,
            ideaAbi,
            ideaContractAddress,
            paymasterAbi,
            paymasterContractAddress,
            wallet.account,
            idea.id,
            stakingContractAddress,
            selectedId,
            setProcessing,
            setMessage,
            handleResetForm
        )
        console.log(votedIdea)
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    const provider = new Web3Provider(window.ethereum)
                    setProvider(provider)
                    const signerInstance = provider.getSigner()
                    setSigner(signerInstance)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    // useEffect(() => {
    //     // Extract the NFT ID or other identifying parameter from the URL
    //     console.log("got to card")
    //     }, []);

    return (
        <React.Fragment>
            <Row>
                {/* Image Column */}
                <Col md="4" className="image-column">
                    <div className="image-wrap">
                        <img
                            src={idea.imageURL}
                            onLoad={() => setShowImageLoading(false)}
                            alt={idea.name}
                            className={showImageLoading ? " hide" : ""}
                            style={{ maxWidth: "100%", height: "auto", display: "block" }}
                        />
                    </div>
                </Col>

                {/* Details Column */}

                <Col md="8" className="details-column">
                    {/* Adjusted Details Column for side-by-side layout */}
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Name:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {idea.name}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Description:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {idea.description}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong># of Votes:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {idea.numVotes}
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Stake Ids:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            <Input
                                disabled={!stakeIds.length}
                                type="select"
                                value={selectedId}
                                onChange={(e) => setSelectedId(e.target.value)}
                                className="form-control w-100 reward-token-id"
                                placeholder="Select Stake ID"
                            >
                                <option>Select your Stake ID</option>
                                {stakeIds.split(",").map((id) => (
                                    <option key={id}>{id}</option>
                                ))}
                            </Input>
                        </Col>
                    </Row>
                    <Row className="detail-row">
                        <Col md="3" className="detail-label">
                            <strong>Vote:</strong>
                        </Col>
                        <Col md="9" className="detail-value">
                            {" "}
                            <Button
                                className="btn submit-btn w-100 blue-btn text-uppercase"
                                onClick={() => handleVoteIdeaVia()}
                                style={{ width: "100%" }}
                            >
                                Vote Idea
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default IdeaCard
